export default __webpack_public_path__ + "static/Litepaper - Japanese-3d32a12d7295b8791164be21e7de2e89.pdf";